(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/amount-input/assets/javascripts/components/amount-input.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/amount-input/assets/javascripts/components/amount-input.trinidad.js');
"use strict";

(() => {
  "use strict";

  var __webpack_require__ = {};
  (() => {
__webpack_require__.n = module => {
var getter = module && module.__esModule ? () => module['default'] : () => module;
      __webpack_require__.d(getter, {
        a: getter
      });
      return getter;
    };
  })();
  (() => {
__webpack_require__.d = (exports, definition) => {
for (var key in definition) {
if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
          });
        }
      }
    };
  })();
  (() => {
__webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
  })();
  var __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": () => (amount_input)
  });
  ; 
  const external_PropTypes_namespaceObject = window["PropTypes"];
  var external_PropTypes_default = __webpack_require__.n(external_PropTypes_namespaceObject);
  ; 
  const external_svs_ui_ReactForm_namespaceObject = window["svs"]["ui"]["ReactForm"];
  ; 
  const _excluded = ["errorMessageDefault", "errorMessageMax", "errorMessageMin", "errorMessageRequired", "helpMessage", "infoMessage", "isCentsAllowed", "isRequired", "isSecondDecimalAllowed", "label", "max", "min", "name", "onBlur", "onChange", "onFocus", "isLessSpace", "value"];
  function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function (n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
      return n;
    }, _extends.apply(null, arguments);
  }
  function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o,
      r,
      i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
  }
  function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
      if (-1 !== e.indexOf(n)) continue;
      t[n] = r[n];
    }
    return t;
  }

  const AmountInput = _ref => {
    let errorMessageDefault = _ref.errorMessageDefault,
      errorMessageMax = _ref.errorMessageMax,
      errorMessageMin = _ref.errorMessageMin,
      errorMessageRequired = _ref.errorMessageRequired,
      helpMessage = _ref.helpMessage,
      infoMessage = _ref.infoMessage,
      isCentsAllowed = _ref.isCentsAllowed,
      isRequired = _ref.isRequired,
      isSecondDecimalAllowed = _ref.isSecondDecimalAllowed,
      label = _ref.label,
      max = _ref.max,
      min = _ref.min,
      name = _ref.name,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      isLessSpace = _ref.isLessSpace,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, _excluded);
    const validateOnlyDigits = data => /^\d+$/.test(data);
    const validateCurrencyWithOneOrTwoDecimals = data => /(^\d+)((,{1}\d{1}\d?)|)$/.test(data);
    const validateCurrencyWithCents = data => /(^\d+)((,{1}\d{1}0)|)$/.test(data);
    const validate = (event, value) => {
      let isValidDigits = validateOnlyDigits(value);
      let isValidMin = parseInt(value, 10) >= min;
      let isValidMax = parseInt(value, 10) <= max;
      if (isCentsAllowed) {
        isValidMin = parseFloat(value.replace(',', '.')) >= parseFloat(min.toString().replace(',', '.'));
        isValidMax = parseFloat(value.replace(',', '.')) <= parseFloat(max.toString().replace(',', '.'));
        if (isSecondDecimalAllowed) {
          isValidDigits = validateCurrencyWithOneOrTwoDecimals(value);
        } else {
          isValidDigits = validateCurrencyWithCents(value);
        }
      }
      const hasValue = value.length > 0;
      let isValid = hasValue && isValidDigits && isValidMax && isValidMin;
      let currentErrorMessage = '';
      if (event === 'onSubmit' && isRequired && !hasValue) {
        currentErrorMessage = errorMessageRequired;
      } else if (!isValidDigits) {
        currentErrorMessage = errorMessageDefault;
      } else if (!isValidMin) {
        currentErrorMessage = errorMessageMin;
      } else if (!isValidMax) {
        currentErrorMessage = errorMessageMax;
      }
      if (event === 'onBlur' || !isRequired) {
        isValid = isValidDigits && isValidMax && isValidMin;
        if (value === '') {
          isValid = true;
          currentErrorMessage = '';
        }
      }
      return {
        errorMessage: currentErrorMessage,
        isValid,
        name
      };
    };
    const checkLengthAndFormat = e => {
      let newValue = e.target.value;
      newValue = newValue.replace('.', ',');
      if (newValue.split(',').length - 1 > 1) {
        newValue = newValue.replace(',', '');
      }
      const commaPos = newValue.indexOf(',');
      const decimalLength = commaPos > -1 ? newValue.substr(commaPos + 1).length : 0;
      if (decimalLength > 2) {
        newValue = newValue.substr(0, newValue.length - 1);
      }
      onChange({
        target: {
          name,
          value: newValue
        }
      });
    };
    return React.createElement(external_svs_ui_ReactForm_namespaceObject.FormContext.Consumer, null, _ref2 => {
      let form = _ref2.form,
        handleBlur = _ref2.handleBlur,
        handleChange = _ref2.handleChange,
        handleFocus = _ref2.handleFocus,
        register = _ref2.register;
      return React.createElement(external_svs_ui_ReactForm_namespaceObject.ControlGroup, {
        errorMessage: form[name] && form[name].errorMessage,
        hasError: form[name] && !form[name].isValid,
        infoMessage: infoMessage,
        isLessSpace: isLessSpace,
        v2: true
      }, React.createElement(external_svs_ui_ReactForm_namespaceObject.Inputv2, _extends({
        autoCapitalize: "off",
        autoComplete: "off",
        autoCorrect: "off",
        inputHelpText: helpMessage,
        inputMode: isCentsAllowed ? 'decimal' : 'numeric',
        label: label,
        lang: "sv-SE",
        max: max,
        min: min,
        name: name,
        onBlur: e => {
          handleBlur(e, onBlur);
        },
        onChange: e => {
          handleChange(e, isCentsAllowed ? checkLengthAndFormat : onChange);
        },
        onFocus: e => {
          handleFocus(e, onFocus);
        },
        refElem: register(name, validate),
        spellCheck: "false",
        step: isCentsAllowed ? null : '1',
        suffix: "kr",
        type: "text",
        value: value
      }, props)));
    });
  };
  AmountInput.defaultProps = {
    errorMessageDefault: 'Felaktigt angivet belopp, minsta insättning 25 kr.',
    errorMessageMax: 'Observera att högsta insättningsbelopp är 25 000 kr.',
    errorMessageMin: 'Observera att minsta insättningsbelopp är 25 kr.',
    errorMessageRequired: 'Du måste ange ett belopp.',
    isCentsAllowed: false,
    isRequired: true,
    isSecondDecimalAllowed: false,
    label: 'Belopp',
    max: 25000,
    min: 25
  };
  AmountInput.__docgenInfo = {
    "description": "",
    "methods": [],
    "displayName": "AmountInput",
    "props": {
      "errorMessageDefault": {
        "defaultValue": {
          "value": "'Felaktigt angivet belopp, minsta ins\xE4ttning 25 kr.'",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "errorMessageMax": {
        "defaultValue": {
          "value": "'Observera att h\xF6gsta ins\xE4ttningsbelopp \xE4r 25 000 kr.'",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "errorMessageMin": {
        "defaultValue": {
          "value": "'Observera att minsta ins\xE4ttningsbelopp \xE4r 25 kr.'",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "errorMessageRequired": {
        "defaultValue": {
          "value": "'Du m\xE5ste ange ett belopp.'",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "isCentsAllowed": {
        "defaultValue": {
          "value": "false",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "isRequired": {
        "defaultValue": {
          "value": "true",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "isSecondDecimalAllowed": {
        "defaultValue": {
          "value": "false",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "custom",
          "raw": "(props, propsName) {\n  if (!props.isCentsAllowed && props[propsName]) {\n    return new Error('Please make sure isCentsAllowed is true, if using isSecondDecimalAllowed');\n  }\n}"
        },
        "required": false
      },
      "label": {
        "defaultValue": {
          "value": "'Belopp'",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "max": {
        "defaultValue": {
          "value": "25000",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "number"
        },
        "required": false
      },
      "min": {
        "defaultValue": {
          "value": "25",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "number"
        },
        "required": false
      },
      "helpMessage": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "infoMessage": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "isLessSpace": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "name": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": true
      },
      "onBlur": {
        "description": "",
        "type": {
          "name": "func"
        },
        "required": false
      },
      "onChange": {
        "description": "",
        "type": {
          "name": "func"
        },
        "required": true
      },
      "onFocus": {
        "description": "",
        "type": {
          "name": "func"
        },
        "required": false
      },
      "value": {
        "description": "",
        "type": {
          "name": "union",
          "value": [{
            "name": "string"
          }, {
            "name": "number"
          }]
        },
        "required": true
      }
    }
  };
  const amount_input = AmountInput;
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).ReactFormInputs = window.svs.ui.ReactFormInputs || {}).AmountInput = __webpack_exports__["default"];
})();

 })(window);